export default __webpack_public_path__ + "static/mfpEnLogo-c81bc40e4d019da5eb8943c458924bb4.png";